import {jwtDecode} from 'jwt-decode';

interface JWTPayload {
  exp?: number;
  [key: string]: unknown;
}

const DEFAULT_BUFFER_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Check if a JWT token is expired or invalid.
 * Uses a buffer (default 5 minutes) to refresh before actual expiration.
 */
export const isTokenExpired = (token: string | null | undefined, bufferMs: number = DEFAULT_BUFFER_MS): boolean => {
  if (!token) return true;

  try {
    const decoded = jwtDecode<JWTPayload>(token);
    if (!decoded.exp) return true;

    const expirationMs = decoded.exp * 1000;
    return expirationMs - bufferMs <= Date.now();
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return true;
  }
};
